<template>
  <div class="category-legend">
    <div v-for="(category, index) in categories"
      :key="category"
      :class="['category-legend-item', stateClasses(category)]"
      @mouseover="onLegendHover(chart, index)"
      @mouseleave="onLegendLeave(chart, index)">
      {{ category }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: { type: Array, default: () => []},
    chart: { type: Object, default: null },
    currentCategories: { type: [Array, String], default: '' },
    hoveredChartId: { type: String, default: '' },
    hoveredCategory: { type: String, default: '' }
  },
  methods: {
    stateClasses(category) {
      return {
        active: typeof this.currentCategories === 'string' ?
          this.currentCategories === category :
          Boolean(this.currentCategories.find(({ name }) => name === category)),
        hover: this.hoveredCategory === category && this.hoveredChartId === this.chart?.options.id
      }
    },
    onLegendHover(chart, index) {
      chart?.series[0].points[index].setState('hover')
      chart?.series[0].points[index].dataLabels[0].show()
    },
    onLegendLeave(chart, index) {
      chart?.series[0].points[index].setState('')
      chart?.series[0].points[index].dataLabels[0].hide()
    }
  }
}
</script>
